import { render, staticRenderFns } from "./menu-role-management.vue?vue&type=template&id=5530900c&scoped=true"
import script from "./menu-role-management.vue?vue&type=script&lang=js"
export * from "./menu-role-management.vue?vue&type=script&lang=js"
import style0 from "./menu-role-management.vue?vue&type=style&index=0&id=5530900c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530900c",
  null
  
)

export default component.exports